import { FormFieldWidget, ModelFieldType, SPI, ViewType, Widget } from '@kunlun/dependencies';
import DealerCreditProfileTabs from './DealerCreditProfileTabs.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Detail,
    ttype: ModelFieldType.Integer,
    widget: 'DealerCreditProfileTab',
    multi: false
  })
)
export class DetailStringDealerCreditProfileTabsFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(DealerCreditProfileTabs);
    return this;
  }
}